import {defineStore} from 'pinia';

import {ModuleBudgetProvide} from '../moduleConst';

import {BaseDictionaryStore} from '../baseDictionaryStore';

import budgetProvideAPI from '@/apis/di/budgetProvideAPI';

const budgetProvideStore = new BaseDictionaryStore(budgetProvideAPI);

export const useBudgetProvideStore = defineStore(ModuleBudgetProvide, {
  state: () => ({
    ...budgetProvideStore.state,
    _config: {
      key: 'budget_provide_id',
      code: 'budget_provide_code',
      name: 'budget_provide_name',
      table: 'di_budget_provide',
      moduleName: 'Mã dự phòng',
      quickFollow: 'active',
      defaultSort: 'budget_provide_code',
    },
    moduleName: 'budgetProvide',
  }),
  actions: {...budgetProvideStore.action},
  getters: {
    ...budgetProvideStore.getters,
  },
});
